import { convertToMillions } from '../convertToMillions';
import { showAsMillions } from '../showAsMillions';

const formatToMillions = (
  value: number,
  decimal = 2,
  options?: Intl.NumberFormatOptions,
) => {
  const millions = convertToMillions(value, decimal);

  return showAsMillions(millions, decimal, {
    ...options,
  });
};

export { formatToMillions };
